import React from 'react';

import { sqlDateToLabel, formatAmountValue } from 'helpers/helpers';
import Grid from '@material-ui/core/Grid';
import H2 from 'apps/Pdf/components/common/H2';


import useGeneralStyles from 'apps/Pdf/styles/general';
import { Currency } from 'enums';
import { AccountEditPlan } from 'stores/workflowStores/newWorkflowPlanStore/model/interfaces';
import Rent from 'apps/Pdf/components/Rent/Rent';

import { TPL_INVESTMENT_PLAN, TPL_NEW_INVESTMENT_PLAN, TPL_DETAIL_INVESTMENT_PLAN } from 'apps/Pdf/templates/InvestmentPlan/InvestmentPlan';
import { TPL_DRAFT_OVERVIEW } from 'apps/Pdf/templates/Overview/Overview';

interface Props {
  data: AccountEditPlan;
  currency: Currency;
  templateType: any;
  change?: boolean;
}

const ChartOverview: React.FC<Props> = ({data, currency, templateType, change}) => {
  const styles = useGeneralStyles();
  const inflation = data?.chart?.inflation || {};
  const rent = !!data.rentApplied;

  return rent ? (
        <Rent
          amountAtRelevantDate={data.amountAtRelevantDate}
          rentApplied={rent}
          rentData={data.rentData}
          currency={currency}
          inflation={inflation}
          personType={data.personType}
          actualInflation={0}
        />
      ) : (
        <>
          <H2>
            Očekávaný vývoj hodnoty majetku v čase&nbsp;
            {inflation?.enabled ? 'v současných (reálných) hodnotách' : 'v budoucích (nominálních) hodnotách'}
          </H2>

          {!data.targetData.targets || data.targetData.targets.length === 0 ? (
            <div className={`${styles.threeColumns} ${styles.center} ${styles.lines}`}>
              <Grid item xs={12}>
                Konec horizontu
              </Grid>
              <Grid item xs={12}>
                Očekávaná hodnota na konci horizontu
              </Grid>
            </div>
          ) : (
            <div className={`${styles.twoColumns} ${styles.center} ${styles.lines}`}>
              <Grid item xs={12}>
                {templateType === TPL_INVESTMENT_PLAN && !change ? 'Počáteční vklad' : 'Aktuální hodnota'}
              </Grid>
              <Grid item xs={12}>
                Očekávaná hodnota v:{' '}
                <strong>
                  {data.chart.displayDate && sqlDateToLabel(data.chart.displayDate!, 'LLLL yyyy')}
                  {data.chart.ageAtDisplay && ` (${data.chart.ageAtDisplay} let)`}
                </strong>
              </Grid>
            </div>
          )}

          {!data.targetData.targets || data.targetData.targets.length === 0 ? (
            <div className={`${styles.threeColumns} ${styles.center} ${styles.lines}`}>
              <Grid item xs={12} className={styles.strongText}>
                {data.chart?.endDate && sqlDateToLabel(data.chart.endDate, 'LLLL yyyy')}
              </Grid>
              <Grid item xs={12} className={styles.strongText}>
                {data.chart?.valueAtEnd?.value && formatAmountValue(data.chart.valueAtEnd.value, currency)}
              </Grid>
            </div>
          ) : (
            <div className={`${styles.twoColumns} ${styles.center} ${styles.lines}`}>
              <Grid item xs={12} className={styles.strongText}>
                {templateType === TPL_INVESTMENT_PLAN &&
                  !change &&
                  data.initial &&
                  formatAmountValue(data.initial.value, currency)}
                {(templateType === TPL_NEW_INVESTMENT_PLAN ||
                  templateType === TPL_DETAIL_INVESTMENT_PLAN ||
                  templateType === TPL_DRAFT_OVERVIEW ||
                  change) &&
                  data.balance &&
                  formatAmountValue(data.balance.value, currency)}
              </Grid>

              <Grid item xs={12} className={styles.strongText}>
                {data.chart?.valueAtDisplay?.value && formatAmountValue(data.chart.valueAtDisplay.value, currency)}
              </Grid>
            </div>
          )}
        </>
      )

};

export default ChartOverview;
